import "core-js/modules/es.array.push.js";
import '@/assets/css/font-awesome-4.7.0/css/font-awesome.css';
import { computed, useAttrs } from 'vue';
export default {
  name: 'XAwesomeIcon',
  props: {
    type: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: [String, Number],
      default: 'fa-1x'
    }
  },
  emits: ['click'],
  setup(props, context) {
    const attrs = useAttrs();
    const iconStyle = computed(() => {
      const styles = {
        ...attrs.style
      };
      if (typeof props.size === 'number') {
        styles.fontSize = `${props.size}px`;
      }
      if (props.color) {
        styles.color = `${props.color}`;
      }
      return styles;
    });
    const iconClass = computed(() => {
      const classes = ['fa', props.type];
      if (typeof props.size === 'string') {
        classes.push(props.size);
      }
      return classes;
    });
    const handleClick = event => {
      context.emit('click', event);
    };
    return {
      iconClass,
      iconStyle,
      handleClick
    };
  }
};